<template>
  <div :class="size">
    <div :class="classNames">
      <a v-if="show_buttons" class="ui icon minus label" @click="minus_clicked">
        <i class="small fitted minus icon"></i>
      </a>
      <input
        v-validate="validate"
        v-if="input_type != 'textarea'"
        :id="_uid"
        :name="name"
        v-model="val"
        :type="input_type"
        :placeholder="placeholder"
        :max="max"
        @input="$emit('input', $event.target.value)"
      />
      <textarea
        v-else
        :rows="rows"
        v-model="val"
        @input="$emit('input', $event.target.value)"
      ></textarea>
      <i v-if="icon" :class="icon"></i>
      <a v-if="show_buttons" class="ui icon plus label" @click="plus_clicked">
        <i class="small fitted plus icon"></i>
      </a>
      <div v-if="label" class="ui basic label">{{ label }}</div>
    </div>
    <div>
      <span v-if="errors.first(name)" class="error">{{
        errors.first(name)
      }}</span>
    </div>
  </div>
</template>

<style scoped>
.measures input,
.measure input {
  width: 65px !important;
  text-align: center !important;
}

.input-left input {
  text-align: left !important;
}

.measure .input {
  opacity: 1 !important;
}

.measure input {
  font-weight: bold !important;
  opacity: 1 !important;
}

.measures .ui.label > .icon {
  margin: 0;
}

.measures input[type='number'] {
  -moz-appearance: textfield;
}

.measures input[type='number']::-webkit-outer-spin-button,
.measures input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.error {
  color: #c00;
}
</style>

<script>
export default {
  name: 'InputText',
  inject: ['$validator'],
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    input_type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    classNames: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'four wide column center aligned'
    },
    show_buttons: {
      type: Boolean,
      default: false
    },
    allowNegativeValue: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    validate: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      val: ''
    }
  },
  watch: {
    value(val) {
      this.val = val
    }
  },
  mounted() {
    this.val = this.value
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// InputText.vue?d9fc192a